import React from 'react';
import { Alert } from 'antd';
import type { CompositionReadOnlyReason } from '../../lib/compositionEditGate';

const BANNER_MESSAGES: Record<CompositionReadOnlyReason, string> = {
  RECOMMENDED:
    'Отображается рекомендуемый состав. Сохранение состава и редактирование станут доступны после инициализации.',
  LOCKED: 'Комплект заблокирован для изменений.',
  FORMED: 'Комплект уже сформирован. Редактирование состава недоступно.',
  NO_PERMISSION:
    'Редактирование состава доступно только бухгалтеру с правом «Редактирование документов».',
  WORKFLOW_READONLY: 'Редактирование состава недоступно в текущем статусе комплекта.',
};

export type CompositionEditBannerProps = {
  readOnlyReason: CompositionReadOnlyReason | null;
};

/**
 * Editor state banner — displays read-only reason from EditGate.
 */
const CompositionEditBanner: React.FC<CompositionEditBannerProps> = ({ readOnlyReason }) => {
  if (!readOnlyReason) {
    return null;
  }

  return (
    <Alert
      type="info"
      showIcon
      className="cp-composition__banner"
      message={BANNER_MESSAGES[readOnlyReason]}
    />
  );
};

export default CompositionEditBanner;
